import api from "../api/axios";

// GET /deliveries/driver-summary?driver_id=&date=  (permission: deliveries:read)
export const fetchDriverSummary = async (driverId, date) => {
  const response = await api.get("/deliveries/driver-summary", {
    params: { driver_id: driverId, date },
  });
  return response.data;
};

// GET /deliveries/driver-summary?date=  (driver_id omitted — bulk mode)
// One request for every driver's collection summary that day, instead of one
// request per driver. Drivers with $0 collected that day are simply absent
// from the array.
export const fetchAllDriverSummaries = async (date) => {
  const response = await api.get("/deliveries/driver-summary", {
    params: { date },
  });
  return response.data;
};
